import { memo, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import _map from 'lodash/map';
import _find from 'lodash/find';
// Local files
import { Root, MessagesContainer, InputContainer } from './Messages.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import MessagesSkeleton from './MessagesSkeleton/MessagesSkeleton';
import Message from './Message/Message';
import NewDivider from './NewDivider/NewDivider';
import Input from './Input/Input';
import useCustomSelector from 'hooks/useCustomSelector';
import useMessages from 'hooks/useMessages';
import { messagesSelectors } from 'features/messages';
import { conversationsSelectors } from 'features/conversations';

const Messages = () => {
  const { getMessages, setLocalMessageFields } = useMessages();
  const divider = useRef(null);
  const messagesEnd = useRef(null);
  const data = useCustomSelector(messagesSelectors.getMessagesData);
  const upPagination = useCustomSelector(messagesSelectors.getUpPaginationData);
  const downPagination = useCustomSelector(messagesSelectors.getDownPaginationData);
  const { id, mode } = useCustomSelector(conversationsSelectors.getConversation);
  const devMode = useCustomSelector(conversationsSelectors.getDevMode);
  const loading = useCustomSelector(messagesSelectors.messagesIsFetching);

  const fetchMessages = (offset, direction = null) => {
    if (!loading) {
      getMessages({ 
        conversation_id: id, 
        offset, 
        ...(!!direction && { direction }), 
        senders: devMode ? 
                ['patient', 'manager', 'bot', 'system'] : 
                 mode === 'manual' ? ['patient', 'manager'] : ['patient', 'manager', 'bot'] 
      })
    }
  };
  const handleContainerScroll = ({ target: { scrollTop, clientHeight, scrollHeight } }) => {
    if ((Math.abs(scrollTop) === 0 || Math.abs(scrollTop) === 1) && !!downPagination.offset) {
      messagesEnd.current?.scrollIntoView(true);
      fetchMessages(downPagination.offset - downPagination.limit >= 0 ? downPagination.offset - downPagination.limit : 0, 'down');
    } 
    if (Math.abs(scrollTop) + clientHeight + 150 >= scrollHeight && upPagination.total_count > upPagination.count + upPagination.offset) {
      fetchMessages(upPagination.limit + upPagination.offset, 'up');
    }
  };

  useEffect(() => {
    const cableMessage = _find(data, (message) => message?.cable);

    if (!!_find(data, (message) => message?.time === 'pending') || !!cableMessage) {
      messagesEnd.current?.scrollIntoView(true);
      !!cableMessage && setLocalMessageFields(cableMessage?.id);
    }
  }, [data, setLocalMessageFields]);

  return (
    <Root>
      { loading ? <MessagesSkeleton /> : <>
        <MessagesContainer onScroll={handleContainerScroll}>
          <Box ref={messagesEnd} sx={{ float: 'left', clear: 'both' }} />
          {_map(data, (item) => item.id !== 'divider' ? 
            <Message key={item.id} message={item} />
          : <NewDivider divider={divider} key={item.id} />
          )}
        </MessagesContainer>
        <InputContainer>
          <Input />
        </InputContainer>
      </> }
    </Root>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Messages {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);